module.exports = __webpack_public_path__ + "img/wxbj-icon.c7122d06.png";